export default __webpack_public_path__ + "static/media/comment_4.f3c13f9d.png";